export const isEmpty = (value?: string | number | boolean | Date | null) => {
  return value === '' || value === undefined || value === null;
};
